import { useEffect, useMemo, useRef, useState } from 'react';

export const useDebounce = <T>(value: T, delay = 500) => {
  const didMount = useRef(false);
  const [debouncedValue, setDebouncedValue] = useState(value);
  const [isDebouncing, setIsDebouncing] = useState(false);

  useEffect(() => {
    if (!didMount.current) {
      didMount.current = true;
      return;
    }

    // eslint-disable-next-line react-hooks/set-state-in-effect -- TODO: fix later
    setIsDebouncing(true);

    const handler = setTimeout(() => {
      setDebouncedValue(value);
      setIsDebouncing(false);
    }, delay);

    return () => {
      clearTimeout(handler);
    };
  }, [value, delay]);

  return { isDebouncing, value: debouncedValue };
};

export const useSearchDebounce = <T = string>({ delay, initialValue }: { delay?: number; initialValue?: T } = {}) => {
  const [search, setSearch] = useState(initialValue);
  const { isDebouncing, value } = useDebounce(search, delay);

  return useMemo(
    () => ({
      isDebouncing,
      searchDebounced: value,
      setSearch,
    }),
    [isDebouncing, value],
  );
};
